import { Component, input, signal } from '@angular/core'
import { Footnotes } from 'src/openapi-client';
import { AtomicBlueprintSupported } from '../../shared/atomic/atomic.component';
@Component({
  selector: 'app-footnotes',
  imports: [],
  templateUrl: './footnotes.component.html',
  styleUrl: './footnotes.component.scss'
})
export class FootnotesComponent implements AtomicBlueprintSupported<Footnotes> {
  data = input.required<Footnotes>();
}
 